import AppointmentLayout from '../../layouts/AppointmentLayout.vue'

export const APPOINTMENT_ROUTES = [
  {
    path: 'appointments',
    component: AppointmentLayout,
    children: [
      {
        path: '',
        name: 'AppointmentBoard',
        component: () => import('./views/AppointmentBoard.vue'),
      },
      {
        path: 'list',
        name: 'AppointmentList',
        component: () => import('./views/AppointmentList.vue'),
      },
    ],
  },
  {
    path: '/appointments/create',
    name: 'CreateAppointment',
    component: () => import('./views/CreateAppointment.vue'),
  },
  {
    path: '/appointments/:id/edit',
    name: 'EditAppointment',
    component: () => import('./views/EditAppointment.vue'),
  },
  {
    path: '/appointments/my-appointments',
    name: 'MyAppointments',
    component: () => import('./views/MyAppointments.vue'),
  },
]
